import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Modal,
  Tabs,
  Tab,
  InputGroup,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  editItem,
  fetchData,
  fetchHistory,
  fetchId,
  fetchIdNoloading,
  fetchTemplate,
  selectId,
  selectIdHistory,
  selectLoading,
  uploadItem,
  uploadValidate,
} from "./regulerDiscSlice";
import { useHistory, useParams } from "react-router";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  CallApi,
  showDialog,
  checkEmptyFields,
  validatePrice,
  paramsMasterAll,
  setOptionsMaster,
  formatterStatus,
  columnsOrder,
  formatCurrency,
  formatQuantity,
  akhirBulan,
  awalBulan,
  formatDate,
  useForceUpdate,
  formatTanggal,
  paramsActiveType,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { Marker } from "../../utility/Marker";
import GoogleMapReact from "google-map-react";
import Select from "react-select";
import { selectUser } from "../../modules/Auth/_redux/authRedux";
import CurrencyInput from "react-currency-input-field";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import SVG from "react-inlinesvg";

import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import { fetchUom, selectUom } from "../uom/uomSlice";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { InputDateRange } from "../../utility/InputDateRange";
import { NavLink } from "react-router-dom";
import InputNumber from "../../utility/InputNumber";
import { useLocation } from "react-router-dom";
import { fetchProduct, selectProduct } from "../product/productSlice";
import { fetchBranch, selectBranch } from "../branch/branchSlice";
import { fetchParam, selectDataParam } from "../param/paramSlice";
import { ModalProduct } from "../../utility/ModalProduct";

export const RegulerDiscCreate = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const user = useSelector(selectUser);
  const dataId = useSelector(selectId);
  const dataProduct = useSelector(selectProduct);
  const { id } = useParams();
  const ref = useRef();
  const { SearchBar } = Search;
  const forceUpdate = useForceUpdate();
  const location = useLocation();
  const dataBranch = useSelector(selectBranch);
  const dataParam = useSelector(selectDataParam);

  const [branch, setBranch] = useState("");
  const [custGroup, setCustGroup] = useState("");
  const [name, setName] = useState("");
  const [status, setStatus] = useState("");
  const [code, setCode] = useState("");
  const [uom, setUom] = useState("");
  const [product, setProduct] = useState({
    product_id: "",
    product_name: "",
    product_code: "",
    uom_description: "",
  });
  const [qty, setQty] = useState(0);
  const [persen, setPersen] = useState(0);
  const [amount, setAmount] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [tableDataHistory, setTableDataHistory] = useState([]);
  const [optionsProduct, setOptionsProduct] = useState([]);
  const [optionsBranch, setOptionsBranch] = useState([]);
  const [optionsCustGroup, setOptionsCustGroup] = useState([]);
  const [show, setShow] = useState(false);

  const [inputSelect, setInputSelect] = useState("");

  const paramsId = {
    regular_discount_id: id,
  };

  useEffect(() => {
    async function fetchMyAPI() {
      if (id !== undefined) {
        await CallApi(paramsId, fetchId, dispatch);
      }
      // await dispatch(fetchProduct(paramsMasterAll));

      await dispatch(fetchBranch(paramsMasterAll));
      await dispatch(
        fetchParam({
          ...paramsMasterAll,
          param_group_code: "CUSTOMER_GROUP",
          is_active: true,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataId) {
      setProduct((prevProduct) => ({
        ...prevProduct,
        product_id: dataId?.product_id,
        product_code: dataId?.product_code,
        product_name: dataId?.product_name,
        uom_description: dataId?.uom_description,
      }));
      setBranch(dataId?.branch_code);
      setCustGroup(dataId?.customer_group);
      setPersen(dataId?.percentage);
      setAmount(dataId?.amount || "0");
      setQty(parseInt(dataId?.min_quantity));
      setStatus(dataId?.is_active);
    }
  }, [dataId]);

  useEffect(() => {
    if (dataProduct.length > 0) {
      setOptionsMaster(
        dataProduct,
        setOptionsProduct,
        "product_id",
        "product_name"
      );
    }
  }, [dataProduct]);

  useEffect(() => {
    if (dataBranch && dataBranch.length > 0) {
      setOptionsMaster(
        dataBranch,
        setOptionsBranch,
        "branch_code",
        "branch_name"
      );
    }
  }, [dataBranch]);

  useEffect(() => {
    if (dataParam.length > 0) {
      setOptionsMaster(
        dataParam,
        setOptionsCustGroup,
        "param_code",
        "param_value"
      );
    }
  }, [dataParam]);

  const handleSave = async () => {
    let hasError = false; // Variable to track if there is any error

    const fields = [
      { value: product?.product_id, message: "input Product", valid: true },
      { value: qty, message: "input Qty", valid: true },
    ];

    const errorMessage = checkEmptyFields(fields);
    if (errorMessage) {
      return showDialog(errorMessage);
    }

    const params = {
      regular_discount_id: id,
      branch_code: branch,
      customer_group: custGroup,
      product_id: product?.product_id,
      min_quantity: qty,
      percentage: persen,
      amount: amount,
      is_active: status,
    };

    try {
      const response =
        id === undefined
          ? await dispatch(addItem(params))
          : await dispatch(editItem(params));
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchIdNoloading, dispatch);
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const handleChangeUom = createChangeHandler(setUom);

  // upload
  const [showUpload, setShowUpload] = useState(false);
  const [fileUpload, setFileUpload] = useState(null);
  const [tableUpload, setTableUpload] = useState([]);

  const handleShowUpload = (data) => {
    setShowUpload(true);
  };

  const handleCloseUpload = () => {
    setTableUpload([]);
    setShowUpload(false);
  };

  const handleUpload = async () => {
    const params = tableUpload.filter(
      (entry) => entry.status_validation === "Success"
    );

    if (params.length === 0) {
      return showDialog("Please upload data first");
    }

    try {
      const response = await dispatch(uploadItem(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchId, dispatch);
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFileUpload(selectedFile);
    validateFile(selectedFile);
  };

  const validateFile = async (file) => {
    if (file) {
      try {
        const response = await dispatch(uploadValidate(file));
        console.log(response, "response");
        if (response.payload.status === 200) {
          const initData = response.payload.data.data.map((item, index) => {
            return {
              ...item,
              no: index + 1,
            };
          });
          setTableUpload(initData);
        } else {
          showErrorDialog(response.payload.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
        console.log(error.message);
      }
    } else {
      console.log("No file uploaded");
    }
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      style: { minWidth: "60px" },
    },

    {
      text: "code",
      dataField: "product_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "name",
      dataField: "product_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "uom",
      dataField: "uom_description",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "branch",
      dataField: "branch_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "customer group",
      dataField: "customer_group_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "min quantity",
      dataField: "min_quantity",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "disc percentage",
      dataField: "percentage",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "disc amount",
      dataField: "amount",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatCurrency,
      align: "right",
    },
    {
      text: "status",
      dataField: "status_validation",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatterStatus,
    },
    {
      text: "message",
      dataField: "message_validation",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
  ];
  const handleDownload = async () => {
    const params = {
      file_type: "REGULAR_DISCOUNT",
    };
    try {
      const response = await dispatch(fetchTemplate(params));
      if (response.payload.status === 200) {
        const blob = new Blob([response.payload.data], {
          type: "application/xlsx",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "REGULAR_DISCOUNT.xlsx";
        link.click();
      } else {
        showErrorDialog(response.payload.data.message);
        console.log("else");
      }
    } catch (error) {
      console.log("catch");
      showErrorDialog(error.message);
    }
  };

  const handleChangeProduct = createChangeHandler(setProduct);
  const handleChangeBranch = createChangeHandler(setBranch);
  const handleChangeCustGroup = createChangeHandler(setCustGroup);
  const handleChangeStatus = createChangeHandler(setStatus);

  const [paramsScroll, setParamsScroll] = useState({
    product_name: inputSelect,
    pageNo: 1,
    pageSize: 10,
  });

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">
            {id === undefined
              ? "Create Regular Discount"
              : "Edit Regular Discount"}
          </CardHeaderTitle>
          <CardHeaderToolbar>
            <Button
              className="btn btn-secondary mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>
            {id === undefined && (
              <Button
                className="btn btn-warning mr-3"
                onClick={handleShowUpload}
              >
                Upload
              </Button>
            )}

            <Button
              className="btn btn-danger"
              onClick={(e) => {
                handleSave();
              }}
            >
              Save
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Form.Group as={Row}>
            <Col sm={6}>
              {id !== undefined && (
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Regular Disc Code</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      value={dataId?.regular_discount_code}
                      disabled
                    />
                  </Col>
                </Form.Group>
              )}
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>
                    Product Code <b className="color-red">*</b>
                  </b>{" "}
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    type="text"
                    disabled
                    value={product?.product_code}
                  />
                </Col>
                <Col>
                  <div
                    className="btn btn-icon btn-light btn-hover-danger btn-sm  mr-3"
                    onClick={() => setShow(true)}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-danger">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/Code/Plus.svg")}
                      />
                    </span>
                  </div>
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Product Name</b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    as="textarea"
                    disabled
                    value={product?.product_name}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Uom</b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    type="text"
                    disabled
                    value={product?.uom_description}
                  />
                </Col>
              </Form.Group>

              {id !== undefined && (
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Status </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={paramsActiveType}
                      value={getValueStatus(status, paramsActiveType)}
                      placeholder="Select ..."
                      onChange={handleChangeStatus}
                    />
                  </Col>
                </Form.Group>
              )}
            </Col>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Branch</b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={optionsBranch}
                    value={getValueStatus(branch, optionsBranch)}
                    placeholder="Select ..."
                    onChange={handleChangeBranch}
                    isClearable={true}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Customer Group</b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={optionsCustGroup}
                    value={getValueStatus(custGroup, optionsCustGroup)}
                    placeholder="Select ..."
                    onChange={handleChangeCustGroup}
                    isClearable={true}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>
                    Min Qty <b className="color-red">*</b>
                  </b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    type="number"
                    min="0"
                    onChange={(e) => {
                      const value = parseInt(e.target.value, 10);
                      if (value >= 0) {
                        setQty(value);
                      } else {
                        setQty(0); // Optional: Set to 0 if value is negative
                      }
                    }}
                    value={qty}
                    className="text-right"
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row} className="align-items-center">
                <Form.Label column sm={3} className="mb-0">
                  <b>Discount</b>
                </Form.Label>
                <Col sm={8} className="d-flex">
                  <InputGroup className="me-2" style={{ width: "50%" }}>
                    <Form.Control
                      type="number"
                      step="0.01"
                      onChange={(e) => {
                        let value = parseFloat(e.target.value);
                        if (isNaN(value)) value = 0;
                        value = Math.min(100, Math.max(0, value));
                        setPersen(value);
                      }}
                      value={persen}
                      max={100}
                      min={0}
                      className="text-right"
                      placeholder="Percentage"
                    />
                    <InputGroup.Text>%</InputGroup.Text>
                  </InputGroup>

                  <InputGroup>
                    <InputGroup.Text>Rp</InputGroup.Text>
                    <CurrencyInput
                      id="input-example"
                      className="form-control text-right"
                      name=""
                      placeholder="Amount"
                      decimalsLimit={2}
                      onValueChange={(value) => {
                        setAmount(value > 0 ? value : 0);
                      }}
                      groupSeparator=","
                      decimalSeparator="."
                      value={amount}
                    />
                  </InputGroup>
                </Col>
              </Form.Group>
            </Col>
          </Form.Group>
        </CardBody>
      </Card>

      <Modal
        show={showUpload}
        onHide={handleCloseUpload}
        size="lg"
        dialogClassName="modal-70"
      >
        <Modal.Header closeButton>
          <Modal.Title>Upload Reguler Discount</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>
                    File <b className="color-red">*</b>
                  </b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    ref={ref}
                    type="file"
                    label="Input "
                    onChange={handleFileChange}
                    custom
                    accept=".xlsx"
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col sm={6}>
              <Button variant="warning" onClick={() => handleDownload()}>
                Download Template
              </Button>
            </Col>
          </Form.Group>

          {tableUpload.length > 0 && (
            <ToolkitProvider
              keyField="no"
              data={tableUpload}
              columns={columns}
              search
            >
              {(props) => (
                <div className="mt-5">
                  <Row>
                    <Col></Col>
                    <Col>
                      <div className="float-right">
                        <SearchBar
                          {...props.searchProps}
                          placeholder="Search .."
                        />
                      </div>
                    </Col>
                  </Row>
                  <div className="table-container ">
                    <BootstrapTable
                      // wrapperClasses="table-responsive"
                      classes="table table-head-custom table-vertical-center"
                      bootstrap4
                      bordered={true}
                      {...props.baseProps}
                    />
                  </div>
                </div>
              )}
            </ToolkitProvider>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseUpload()}>
            Close
          </Button>
          <Button variant="danger" onClick={handleUpload}>
            Save
          </Button>{" "}
        </Modal.Footer>
      </Modal>

      <ModalProduct show={show} setShow={setShow} setProduct={setProduct} />
    </>
  );
};
